import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img from "../../images/articles/brooke-cagle--uHVRvDr7pg-unsplash.jpeg";

function StudentOpplevelse() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.studentExperience.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.studentExperience.description")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/artikler/tydelig-kommunikasjon-styrker-studentopplevelsen"
        />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-4">
            {i18next.t("pages.articles.list.studentExperience.title")}
          </h1>
          <p className="text-xl mb-2">
          {i18next.t("pages.articles.list.studentExperience.description")}
          </p>
          
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.studentExperience.date")}
          </p>
        </div>
        <div className="w-full md:w-2/5">
          <img
            src={article_img}
            className="w-full"
            alt={i18next.t("pages.articles.list.studentExperience.imageAlt")}
          />
          <p className="text-sm text-secondary mt-2">
            {i18next.t("pages.articles.credit.photoBy")}{" "}
            <a
              href="https://unsplash.com/@brookecagle?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"
              className="underline hover:text-contrast-ink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Brooke Cagle
            </a>{" "}
            {i18next.t("pages.articles.credit.on")}{" "}
            <a
              href="https://unsplash.com/photos/a-group-of-friends-at-a-coffee-shop--uHVRvDr7pg?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"
              className="underline hover:text-contrast-ink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Unsplash
            </a>
          </p>
        </div>
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className="max-w-sm">
          <p className="mb-2">
          {i18next.t("pages.articles.list.studentExperience.sections.intro.content1")}
          </p>
          <p className="mb-2">
          {i18next.t("pages.articles.list.studentExperience.sections.intro.content2")}
          </p>
            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.studentExperience.sections.notReach.title")}
            </h2>
            <p className="mb-2">
              {i18next.t("pages.articles.list.studentExperience.sections.notReach.content1")}
            </p>
            <p className="mb-2">
              {i18next.t("pages.articles.list.studentExperience.sections.notReach.content2")}
              <a href="/artikler/gjor-dokumentene-dine-tilgjengelige" className="underline hover:text-contrast-ink font-bold">
                {i18next.t("pages.articles.list.studentExperience.sections.notReach.link")}
              </a>
              {i18next.t("pages.articles.list.studentExperience.sections.notReach.content3")}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.studentExperience.sections.quality.title")}
            </h2>
            <p className="mb-2" >
              {i18next.t("pages.articles.list.studentExperience.sections.quality.content1")}
            </p>
            <p className="mb-2">
              {i18next.t("pages.articles.list.studentExperience.sections.quality.content2")}
              <a href="/artikler/tilgjengelighetsdirektivet" className="underline hover:text-contrast-ink font-bold">
                {i18next.t("pages.articles.list.studentExperience.sections.quality.link")}
              </a>
              {i18next.t("pages.articles.list.studentExperience.sections.quality.content3")}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.studentExperience.sections.howHelp.title")}
            </h2>
            <p className="mb-2">
              {i18next.t("pages.articles.list.studentExperience.sections.howHelp.content1")}
              <a href="/docengine" className="underline hover:text-contrast-ink font-bold">
                {i18next.t("pages.articles.list.studentExperience.sections.howHelp.link")}
              </a>
              {i18next.t("pages.articles.list.studentExperience.sections.howHelp.content2")}
            </p>
            <p className=" mb-2">
              {i18next.t("pages.articles.list.studentExperience.sections.howHelp.content3")}
            </p>
            <p className="mt-6 font-bold">
              {i18next.t("pages.articles.list.studentExperience.sections.conclusion")}
              <a href="/skjema/kontakt-oss" className="font-bold underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.studentExperience.sections.cta")}
              </a>
              {i18next.t("pages.articles.list.studentExperience.sections.ctaFollow")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StudentOpplevelse;



